// ./src/pages/Privacy/index.js
import React from 'react';

const Privacy = () => (
  <div className="max-w-3xl mx-auto px-6 py-12">
    <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
    <div className="prose prose-lg">
      <p className="text-gray-600 mb-6">
        Last updated: December 28, 2025
      </p>
      
      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Introduction</h2>
      <p className="text-gray-600 mb-6">
        Welcome to DeltaOps.app. We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Information We Collect</h2>
      <p className="text-gray-600 mb-6">
        <strong>Personal Information:</strong> Name, email address, and other contact details you provide when signing up.<br/>
        <strong>Usage Data:</strong> Information on how you use our service, including access times, pages viewed, and actions taken.<br/>
        <strong>Change Metadata:</strong> Descriptions, timestamps, and links to pull requests or deployment records related to system changes.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. How We Use Your Information</h2>
      <p className="text-gray-600 mb-6">
        <strong>Provide Services:</strong> To deliver and maintain our services, including processing your requests and managing your account.<br/>
        <strong>Improve Services:</strong> To analyze usage patterns and enhance the functionality and user experience of our platform.<br/>
        <strong>Communication:</strong> To send you updates, newsletters, and promotional materials (with your consent).
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Data Retention</h2>
      <p className="text-gray-600 mb-6">
        We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Data Sharing and Third Parties</h2>
      <p className="text-gray-600 mb-6">
        We do not sell or rent your personal information. We may share data with trusted third-party service providers who assist us in operating our website and conducting our business, provided they agree to keep this information confidential.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Cookies and Tracking Technologies</h2>
      <p className="text-gray-600 mb-6">
        Our website uses cookies and similar tracking technologies to enhance your browsing experience. You can manage your cookie preferences through your browser settings.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Your Rights</h2>
      <p className="text-gray-600 mb-6">
        Depending on your location, you may have the right to:
        <ul className="list-disc list-inside mt-2">
          <li><strong>Access:</strong> Request access to your personal data.</li>
          <li><strong>Correction:</strong> Request correction of inaccurate data.</li>
          <li><strong>Deletion:</strong> Request deletion of your personal data.</li>
          <li><strong>Restriction:</strong> Request restriction of processing your data.</li>
          <li><strong>Portability:</strong> Request transfer of your data to another service.</li>
        </ul>
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Children's Privacy</h2>
      <p className="text-gray-600 mb-6">
        Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. International Data Transfers</h2>
      <p className="text-gray-600 mb-6">
        Your information may be transferred to and maintained on servers located outside your country. We ensure appropriate safeguards are in place to protect your data during such transfers.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Data Security</h2>
      <p className="text-gray-600 mb-6">
        We implement industry-standard security measures to protect your data from unauthorized access, alteration, disclosure, or destruction.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Changes to This Privacy Policy</h2>
      <p className="text-gray-600 mb-6">
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
      </p>

      <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">12. Contact Us</h2>
      <p className="text-gray-600">
        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:marcus@DeltaOps.app" className="text-blue-600 underline">marcus@DeltaOps.app</a>.
      </p>
    </div>
  </div>
);

export default Privacy;
